import FadeInSection from '../../../components/feature/FadeInSection';

const features = [
  {
    icon: 'ri-shield-check-line',
    title: '安心の個人情報管理',
    description: 'お相手のプライバシーを徹底管理。安心してお相手探しができます。',
  },
  {
    icon: 'ri-time-line',
    title: 'あなたのペースで',
    description: '無理な活動は一切なし。お仕事やご家族の都合に合わせてご活動いただけます。',
  },
  {
    icon: 'ri-user-heart-line',
    title: 'シニア専門カウンセラー',
    description: '50代以上の婚活に精通したカウンセラーが、一対一で丁寧にサポートします。',
  },
];

export default function ServiceFeaturesSection() {
  return (
    <section className="section-padding" style={{ background: '#fff8f2' }}>
      <div className="content-width">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-14">
          {features.map((f, i) => (
            <FadeInSection key={i} delay={i * 100}>
              <div className="card-base text-center h-full">
                <div
                  className="mx-auto mb-5 flex items-center justify-center w-16 h-16 rounded-full"
                  style={{ background: '#fff8f2' }}
                >
                  <span className="flex items-center justify-center w-9 h-9">
                    <i className={`${f.icon} text-[#e8934e] text-3xl`}></i>
                  </span>
                </div>
                <h3 style={{ color: '#8b4513', marginBottom: '12px' }}>{f.title}</h3>
                <p style={{ color: '#6b5a4e', lineHeight: '1.9', fontSize: '16px' }}>{f.description}</p>
              </div>
            </FadeInSection>
          ))}
        </div>

        {/* Service Summary */}
        <FadeInSection>
          <div
            className="rounded-2xl p-10"
            style={{ background: '#fff', border: '2px solid #e8934e' }}
          >
            <h3 style={{ color: '#8b4513', marginBottom: '16px', fontSize: '22px' }}>
              こんな方におすすめです
            </h3>
            <ul className="space-y-4">
              {[
                '結婚・再婚を真剣にお考えの50代・60代・70代の方',
                '初婚・再婚問わず、誠実なパートナーをお探しの方',
                'お茶飲み友達などのパートナーが欲しい方',
                '初めてで、何から始めたらいいか分からない方',
                '自分のペースでじっくりと活動したい方',
              ].map((item, i) => (
                <li key={i} className="flex items-start gap-3">
                  <span className="flex items-center justify-center w-5 h-5 mt-1 shrink-0">
                    <i className="ri-checkbox-circle-fill text-[#5a9e6f] text-lg"></i>
                  </span>
                  <span style={{ color: '#4a3728', fontSize: '17px', lineHeight: '1.8' }}>{item}</span>
                </li>
              ))}
            </ul>
          </div>
        </FadeInSection>
      </div>
    </section>
  );
}
